<template>
  <div class="container-fluid">
    <div class="row">
      <!--  v-if="isCardVisible(69)"  -->
      <div class="col-md-3">
        <div class="card mt-3 clearfix">
          <div class="card-body">
            <div class="row">
              <div class="col">
                <h6 class="card-title text-uppercase text-muted mb-0 font-weight-bold">TAKİP NUMARASI BEKLEYENLER</h6>
                <span class="h2 font-semi-bold mb-0">{{numbers.NEED_TRACKINGNUMBER}}</span>
              </div>
              <div class="col-auto">
                <div class="icon icon-shape bg-danger text-white rounded-circle shadow">
                  <i class="far fa-envelope text-white"></i>
                </div>
              </div>
            </div>
            <p class="mt-3 mb-0 text-muted text-sm">
              <span class="text-success mr-2"><i class="fas fa-user text-success"></i>&nbsp;&nbsp;Ebru Karataş</span>
              <span class="text-nowrap"></span>
            </p>
          </div>
        </div>
      </div>
      <!-- v-if="isCardVisible(70) || isCardVisible(71) || isCardVisible(65)" -->
      <div class="col-md-3">
        <div class="card mt-3 clearfix">
          <div class="card-body">
            <div class="row">
              <div class="col">
                <h6 class="card-title text-uppercase text-muted mb-0 font-weight-bold">TEKNİK SERVİSTEKİLER</h6>
                <span class="h2 font-semi-bold mb-0">{{numbers.IN_TECHCREW}}</span>
              </div>
              <div class="col-auto">
                <div class="icon icon-shape bg-success text-white rounded-circle shadow">
                  <i class="fas fa-cog text-white"></i>
                </div>
              </div>
            </div>
            <p class="mt-3 mb-0 text-muted text-sm">
              <span class="text-success mr-2"><i class="fas fa-user text-success"></i>&nbsp;&nbsp;Şaban Durdu</span>
              <span class="text-nowrap"></span>
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card mt-3 clearfix">
          <div class="card-body">
            <div class="row">
              <div class="col">
                <h6 class="card-title text-uppercase text-muted mb-0 font-weight-bold">TEKLİF TALEPLERİ</h6>
                <span class="h2 font-semi-bold mb-0">{{numbers.TEKLIFLER}}</span>
              </div>
              <div class="col-auto">
                <div class="icon icon-shape bg-info text-white rounded-circle shadow">
                  <i class="far fa-file text-white"></i>
                </div>
              </div>
            </div>
            <p class="mt-3 mb-0 text-muted text-sm">
              <span class="text-success mr-2"><i class="fas fa-user text-success"></i>&nbsp;&nbsp;Ebru Karataş</span>
              <span class="text-nowrap"></span>
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card mt-3 clearfix">
          <div class="card-body">
            <div class="row">
              <div class="col">
                <h6 class="card-title text-uppercase text-muted mb-0 font-weight-bold">ARANMA TALEPLERİ</h6>
                <span class="h2 font-semi-bold mb-0">{{numbers.ARANMALAR}}</span>
              </div>
              <div class="col-auto">
                <div class="icon icon-shape bg-primary text-white rounded-circle shadow">
                  <i class="fas fa-phone text-white"></i>
                </div>
              </div>
            </div>
            <p class="mt-3 mb-0 text-muted text-sm">
              <span class="text-success mr-2"><i class="fas fa-user text-success"></i>&nbsp;&nbsp;Ebru Karataş</span>
              <span class="text-nowrap"></span>
            </p>
          </div>
        </div>
      </div>
      <!--
      <div class="col-md-3" v-if="isCardVisible(0)">
        <div class="card mt-3 clearfix">
          <div class="card-body">
            <div class="row">
              <div class="col py-0 px-0">
                <h5 class="card-title text-uppercase text-muted mb-0">İŞLEMİ TAMAMLANANLAR</h5>
                <span class="h2 font-semi-bold mb-0">{{numbers.IN_FINISHED}}</span>
              </div>
              <div class="col-auto">
                <div class="icon icon-shape bg-primary text-white rounded-circle shadow">
                  <img src="static/butterfly_.svg" width="32" height="32" />
                </div>
              </div>
            </div>
            <p class="mt-3 mb-0 text-muted text-sm">
              <span class="text-success mr-2"><i class="fas fa-user text-success"></i>&nbsp;&nbsp;Duygu Süzgün</span>
              <span class="text-nowrap"></span>
            </p>
          </div>
        </div>
      </div>
      -->
      <!--
      <div class="col-md-3" v-if="!isCardVisible(0)">
        <div class="card mt-3 clearfix" :class="{'bg-gr-info' : getDifference == 0, 'bg-gr-danger' : getDifference > 0 || entrance}">
          <div class="card-body">
            <div class="row">
              <div class="col py-0 px-0">
                <h5 class="card-title text-white mb-0">{{this.entrance.SERVER_TIME === null ? 'Bugün kartınızı okutmadınız' : 'Ofise Girişiniz'}}</h5>
                <span v-if="this.entrance.SERVER_TIME === null" class="h2 font-semi-bold text-white d-block">...</span>
                <span v-else class="h2 font-semi-bold text-white d-block">{{getDifference == 0 ? 'Zamanında' : getDifference + ' dk. geç'}}</span>
              </div>
            </div>
            <p class="mt-3 mb-0 text-muted text-sm">
              <span class="card-text mr-2"><i class="far fa-clock"></i>&nbsp;&nbsp;{{this.entrance.SERVER_TIME_FORMATTED || '...'}}</span>
              <span class="card-text text-white"><router-link class="text-white" :to="'/personel/' + this.entrance.IDENTITY_CODE"><i class="far fa-calendar"></i>&nbsp;&nbsp;Aylık raporunuzu görmek için tıklayınız.</router-link></span>
            </p>
          </div>
        </div>
      </div>
    </div>
    -->
    </div>
    <!--
    <div class="row mt-4">
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-12" v-if="isCardVisible(0)">
            <div class="card card-table mb-4">
              <div class="caption-slx align-middle">
                <span class="text-left float-left">Seçilen Ayda Dolan Sözleşmeler</span>
                <span class="text-right float-right border-success border btn-more-radius">{{monthOfYear}}</span>
              </div>
              <div class="header">
                <div class="row">
                  <div class="col-4">MÜŞTERİ</div>
                  <div class="col-2 text-center">SÖZLEŞME TAR.</div>
                  <div class="col-2 text-center">BİTİŞ TARİHİ</div>
                  <div class="col-2 text-center">ARAÇ SAYISI</div>
                  <div class="col-2 text-center">TOPLAM AİDAT</div>
                </div>
              </div>
              <div class="content">
                <v-wait for="contracts-loading">
                  <template slot="waiting">
                    <div class="vue-wait-class">
                      <img src="static/loading.svg" />
                      <p>Sözleşmeler Listeleniyor...</p>
                    </div>
                  </template>
                  <div class="row" v-for="(contractModel, index) in contractsPaginated" v-bind:key="'cetm-' + index">
                    <div class="col-4 text-truncate"><a href="#" @click="showContractPopup(contractModel.CONTRACT_ID)">{{contractModel.CUSTOMER_TITLE}}&nbsp;<span class="text-muted">({{contractModel.CUSTOMER_ID}})</span></a></div>
                    <div class="col-2 text-center text-truncate">{{contractModel.ContractDate}}</div>
                    <div class="col-2 text-center text-truncate">{{contractModel.CONTRACT_END}}</div>
                    <div class="col-2 text-center">{{contractModel.VehicleCount}}</div>
                    <div class="col-2 text-center">{{contractModel.TOTALBILL}}</div>
                  </div>
                </v-wait>
              </div>
              <div class="footer">
                <nav aria-label="Page navigation example">
                  <ul class="pagination justify-content-end">
                    <li class="page-item" :class="{'active' : activePageContracts == 0}"><a class="page-link" @click="setPage(0, 2)">1</a></li>
                    <li class="page-item" :class="{'active' : activePageContracts == 1}"><a class="page-link" @click="setPage(1, 2)">2</a></li>
                    <li class="page-item" :class="{'active' : activePageContracts == 2}"><a class="page-link" @click="setPage(2, 2)">3</a></li>
                    <li class="page-item" :class="{'active' : activePageContracts == 3}"><a class="page-link" @click="setPage(3, 2)">4</a></li>
                    <li class="page-item" :class="{'active' : activePageContracts == 4}"><a class="page-link" @click="setPage(4, 2)">5</a></li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-12" v-if="isCardVisible(0)">
            <div class="card card-table mb-4">
              <div class="caption-slx align-middle">
                <span class="text-left float-left">Personel Giriş Kontrolü</span>
                <button @click="changeEntranceDateReport(false)" class="date-change ml-2 float-right btn-more-radius border-success border">
                  <i class="fas fa-angle-right"></i>
                </button>
                <span class="text-right float-right border-success border btn-more-radius">{{todayFormatted}}</span>
                <button @click="changeEntranceDateReport(true)" class="date-change mr-2 float-right btn-more-radius border-success border">
                  <i class="fas fa-angle-left"></i>
                </button>
              </div>
              <div class="header">
                <div class="row">
                  <div class="col-3">PERSONEL</div>
                  <div class="col-3 text-center">GİRİŞ</div>
                  <div class="col-3 text-center">ÇIKIŞ</div>
                  <div class="col-3 text-center">TOPLAM GECİKME</div>
                </div>
              </div>
              <div class="content">
                <div class="row" v-for="(personal, index) in entranceReport" v-bind:key="'personal-' + index">
                  <div class="col-3 text-truncate">
                    <router-link :to="'/personel/' + personal.IDENTITY_CODE" class="btn-link">
                      {{personal.PERSONAL_NAME}}
                    </router-link>
                  </div>
                  <div class="col-3 text-center text-truncate">
                    <small class="text-muted">{{personal.ENTRANCE_TIME_FORMATTED}}</small>&nbsp;&bull;&nbsp;
                    <small :class="parseLateAsClass(personal.LATE_TODAY)">{{parseLateAsText(personal.LATE_TODAY)}}</small></div>
                  <div class="col-3 text-center text-truncate">
                    <small class="text-muted">{{personal.LEFT_TIME_FORMATTED}}</small>&nbsp;&bull;&nbsp;
                    <small :class="parseEarlyAsClass(personal.EARLY_LEFT)">{{parseEarlyAsText(personal.EARLY_LEFT)}}</small></div>
                  <div class="col-3 text-center">{{personal.LATE_TOTAL}} dk.</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="card card-table mb-4">
              <div class="caption-slx">En Uzun Süreli Bekleyen Arızalı Cihazlar</div>
              <div class="header">
                <div class="row">
                  <div class="col-4">SERİ NO.</div>
                  <div class="col-4">MÜŞTERİ</div>
                  <div class="col-2 text-center">DURUM</div>
                  <div class="col-2 text-center">SÜRE</div>
                </div>
              </div>
              <div class="content">
                <div class="row" v-for="(device, index) in devicesPaginated" v-bind:key="'device-' + index">
                  <div class="col-4 text-truncate">{{device.DEVICE_ID}} &bull; <small class="text-muted">{{device.DEVICE_LABEL}}</small></div>
                  <div class="col-4 text-truncate">{{device.CUSTOMER_TITLE}} &bull; <small class="text-muted">{{device.VEHICLE_NAME}}</small></div>
                  <div class="col-2 text-center"><i class="fas fa-circle" :class="parseStatusAsClass(device.STATUS)"></i></div>
                  <div class="col-2 text-center">{{device.WAITING_DAY}} GÜN</div>
                </div>
              </div>
              <div class="footer">
                <nav aria-label="Page navigation example">
                  <ul class="pagination justify-content-end">
                    <li class="page-item" :class="{'active' : activePageDevice == 0}"><a class="page-link" @click="setPage(0, 1)">1</a></li>
                    <li class="page-item" :class="{'active' : activePageDevice == 1}"><a class="page-link" @click="setPage(1, 1)">2</a></li>
                    <li class="page-item" :class="{'active' : activePageDevice == 2}"><a class="page-link" @click="setPage(2, 1)">3</a></li>
                    <li class="page-item" :class="{'active' : activePageDevice == 3}"><a class="page-link" @click="setPage(3, 1)">4</a></li>
                    <li class="page-item" :class="{'active' : activePageDevice == 4}"><a class="page-link" @click="setPage(4, 1)">5</a></li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="card card-table card-dark">
              <div class="caption-slx">Kritik Seviyede Azalmış Malzemeler</div>
              <div class="header">
                <div class="row">
                  <div class="col-6">MALZEME ADI</div>
                  <div class="col-4">KULLANIM ALANI</div>
                  <div class="col-2 text-center">ADET</div>
                </div>
              </div>
              <div class="content">
                <div class="row" v-for="(critical, index) in criticalsPaginated" v-bind:key="'critical-' + index">
                  <div class="col-6 text-truncate">{{critical.MALZEME_NAME}} - {{critical.MALZEME_CODE}}</div>
                  <div class="col-4 text-truncate" v-if="!critical.IN_USED_PRODUCTS">-</div>
                  <div class="col-4 text-truncate" v-else>
                    <span v-for="(inused, iuIndex) in critical.IN_USED_PRODUCTS.split(',')"
                      v-bind:key="'inused-' + iuIndex"
                      class="badge font-light badge-pill badge-primary mr-1">{{inused}}</span>
                  </div>
                  <div class="col-2 text-center">{{critical.MALZEME_LENOI}}</div>
                </div>
              </div>
              <div class="footer">
                <nav aria-label="Page navigation example">
                  <ul class="pagination justify-content-end">
                    <li class="page-item" :class="{'active' : activePage == 0}"><a class="page-link" @click="setPage(0, 0)">1</a></li>
                    <li class="page-item" :class="{'active' : activePage == 1}"><a class="page-link" @click="setPage(1, 0)">2</a></li>
                    <li class="page-item" :class="{'active' : activePage == 2}"><a class="page-link" @click="setPage(2, 0)">3</a></li>
                    <li class="page-item" :class="{'active' : activePage == 3}"><a class="page-link" @click="setPage(3, 0)">4</a></li>
                    <li class="page-item" :class="{'active' : activePage == 4}"><a class="page-link" @click="setPage(4, 0)">5</a></li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    -->
    <ContractDetailPopup ref="contractPopup" :contractId="selectedContractId"/>
    <InvoicePopupPage ref="invoicePopup"/>
  </div>
</template>

<script>
/* eslint-disable */

import axios from 'axios'
import moment from 'moment'
import ContractPopupPage from '../partials/ContractPopupPage'
import InvoicePopupPage from '../partials/InvoicePopupPage'

export default {
  name: 'HelloWorld',
  components: {
    'ContractDetailPopup': ContractPopupPage,
    'InvoicePopupPage': InvoicePopupPage,
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      numbers: {},
      entrance: {},
      entranceReport: [],
      entranceReportDate: 0,
      criticals: [],
      devicesLongTime: [],
      activePage: 0,
      activePageDevice: 0,
      activePageContracts:0,
      contractsList: [],
      selectedContractId: 0
    }
  },
  computed: {
    getPersonelId: function() { return this.$store.getters.getPersonelId; },
    getPersonelName: function() { return this.$store.getters.getPersonelName; },
    getSessionId: function() { return this.$store.getters.getSessionId; },
    getDifference: function() { return this.entrance.DIFFERENCE < 0 ? 0 : this.entrance.DIFFERENCE; },
    criticalsPaginated: function() {
      if(this.criticals.length == 0)
        return [];

      let arr = []
      for(let i = (this.activePage * 5); i < (this.activePage * 5) + 5; i++) {
        arr.push(this.criticals[i])
      }
      return arr;
    },
    devicesPaginated: function() {
      if(this.devicesLongTime.length == 0)
        return [];
        
      let arr = []
      for(let i = (this.activePageDevice * 5); i < (this.activePageDevice * 5) + 5; i++) {
        arr.push(this.devicesLongTime[i])
      }
      return arr;
    },
    contractsPaginated: function() {
      if(this.contractsList.length == 0)
        return [];

      let arr = []
      for(let i = (this.activePageContracts * 5); i < (this.activePageContracts * 5) + 5; i++) {
        arr.push(this.contractsList[i])
      }
      return arr;
    },
    entranceReportDateString: {
      get: function() {
        return moment().add(this.entranceReportDate, 'days').format('YYYY-MM-DD')
      }
    },
    todayFormatted: {
      get: function() {
        return moment().add(this.entranceReportDate, 'days').format('D MMMM YYYY')
      }
    },
    monthOfYear: {
      get: function() {
        return moment().add(this.entranceReportDate, 'month').format('MMMM YYYY')
      }
    }
  },
  methods: {
    isCardVisible(perId) { return this.getPersonelId == 3 || this.getPersonelId == 24 || this.getPersonelId ==  perId; },
    async getNumbers() {
      axios.post('/api/session/numbers')
      .then(response => {
        this.numbers = response.data[0];
        //$('#conversationModal').modal('show')
      })
    },
    async getEntrance() {
      axios.post('/api/session/entrance')
      .then(response => {
        this.entrance = response.data[0];
        console.log('SERVER TIME : ' + this.entrance.SERVER_TIME)
      })
    },
    async getEntranceReportBasic() {
      axios.post('/api/session/entrance-report?date=' + this.entranceReportDateString)
      .then(response => {
        this.entranceReport = response.data;
        let entranceWorking = response.data;
        let nowIndex = 0;
        let foundIndex = 0;
        let nowIdCode = null;
        
        let normalEntrance = moment({h: 9, m: 0, s: 0}).add(this.entranceReportDate, 'days')
        let normalOutrance = moment({h: 18, m: 0, s: 0}).add(this.entranceReportDate, 'days')

        for(let i = 0; i < entranceWorking.length; i++) {
          if(nowIdCode == null) {
            nowIdCode = entranceWorking[i].IDENTITY_CODE;
            nowIndex = i;

            let iEntrance = moment(entranceWorking[i].ENTRANCE_TIME)
            entranceWorking[i].LATE_TODAY = iEntrance.diff(normalEntrance, 'minutes')
            iEntrance = null;

          } else {
            if(entranceWorking[i].IDENTITY_CODE === nowIdCode) {
              foundIndex = i;
              entranceWorking[nowIndex].LEFT_TIME = entranceWorking[i].ENTRANCE_TIME
              entranceWorking[nowIndex].LEFT_TIME_FORMATTED = entranceWorking[i].ENTRANCE_TIME_FORMATTED
              
              let iOutrance = moment(entranceWorking[nowIndex].LEFT_TIME)
              entranceWorking[nowIndex].EARLY_LEFT = iOutrance.diff(normalOutrance, 'minutes')
              
              entranceWorking[nowIndex].LATE_TOTAL = 
                (parseInt(entranceWorking[nowIndex].LATE_TODAY) < 0 ? 0 : parseInt(entranceWorking[nowIndex].LATE_TODAY))
                + (entranceWorking[nowIndex].EARLY_LEFT > 0 ? 0 : Math.abs(parseInt(entranceWorking[nowIndex].EARLY_LEFT)))

              entranceWorking.splice(foundIndex, 1)

              iOutrance = null;
              i = nowIndex;
              nowIdCode = null;
              nowIndex = 0
              foundIndex = 0
              continue;
            }
          }
        }

        normalEntrance = null;
        normalOutrance = null;
        this.entranceReport = entranceWorking;
      })
    },
    async getCriticals() {
      axios.post('/api/stok/malzemeler-critical')
      .then((response) => this.criticals = response.data)
    },
    async getDevicesLongTime() {
      axios.post('/api/arizakayit/long-time')
      .then((response) =>
        this.devicesLongTime = response.data)
    },
    setPage(index, type) {
      if(type == 0)
        this.activePage = index
      else if(type == 1)
        this.activePageDevice = index
      else
        this.activePageContracts = index
    },
    parseStatusAsClass(arizaDurum) {
      if(arizaDurum == 0)
        return "text-primary"
      else if(arizaDurum == 1)
        return "text-warning"
      else if(arizaDurum == 2)
        return "text-success"
      else if(arizaDurum == 3)
        return "text-info"
      else if(arizaDurum == 4)
        return "text-danger"
      else if(arizaDurum == 5)
        return "text-secondary"
      else if(arizaDurum == 6)
        return "text-outline btn-outline-danger"
    },
    parseLateAsClass(late) {
      if(late <= 0)
        return 'text-success'
      else
        return 'text-danger'
    },
    parseLateAsText(late) {
      if(late <= 0)
        return 'Zamanında'
      else
        return late + " dk. geç"
    },
    parseEarlyAsClass(early) {
      if(early < 0)
        return 'text-danger'
      else
        return 'text-success'
    },
    parseEarlyAsText(early) {
      if(early < 0)
        return Math.abs(early) + " dk. erken"
      else
        return "Zamanında"
    },
    changeEntranceDateReport(addMode) {
      let addVal = addMode ? -1 : 1
      this.entranceReportDate = this.entranceReportDate + addVal;
      this.getEntranceReportBasic()
    },
    async getContracts() {
      this.$wait.start('contracts-loading');
      axios.post('/api/a1/contracts-with-function?retailerId=1&month=6&function=7')
      .then(response => {
        this.contractsList = response.data;
        this.$wait.end('contracts-loading');
      })
      .catch(err => { this.$wait.end('contracts-loading') })
    },
    showContractPopup(id) {
      this.selectedContractId = id;
      $("#contractDetailModal").modal('show');
      this.$refs.contractPopup.getContractById(id);
    }
  },
  beforeMount() {
    moment.locale('tr')

    this.getNumbers()
    if(this.getPersonelId == 3 || this.getPersonelId == 24) {
      this.getEntranceReportBasic()
      this.getContracts()
    }
    else
      this.getEntrance()

    this.getCriticals()
    this.getDevicesLongTime()
  },
  mounted() {
  }
}
</script>

<style scoped>

  iframe {
    border: 0;
    width: 100%;
    height: 640px;
  }

  .text-decoration-none {
    color: #FFF;
    text-decoration: none;
  }

  body {
    background-color: #111939 !important;
  }

  .card {
    border: 1px solid #F0F0F0;
    background: #fff;
    box-shadow: 0px 5px 10px -5px rgba(0,0,0,0.125);
  }

  .card-body {
    
    color: #FFFFFF !important;
  }

  .card-body * {
    margin-bottom: 0px;
  }

  p.card-text {
    font-size: 4.2rem;
    line-height: 4.2rem;
  }
  
  .card-text, .card-text i {
    color: #fff !important;
  }

  .card-footer {
    background-color: transparent;
    border: none;
    color: #FFF;
  }
  
  .card-header {
    background-color: #FFF;
    font-size: 85px;
    font-weight: 400;
  }

  .bg-pastel {
    background-color: #f8f9fe;
  }

  .hot-bg {
    background-color: #FFE53B;
    background-image: linear-gradient(147deg, #FFE53B 0%, #FF2525 74%);
  }

  .bg-gr-default {
    background: linear-gradient(87deg,#172b4d 0,#1a174d 100%)!important;
  }

  .bg-gr-primary {
    background: linear-gradient(135deg,#5e72e4 0,#825ee4 100%)!important;
  }

  .bg-gr-info {
    background: linear-gradient(135deg,#11cdef 0,#1171ef 100%) !important;
  }
  
  .bg-gr-danger {
    background: linear-gradient(135deg,#f5365c 0,#f56036 100%)!important;
  }

  .number-sheet {
    width: 100%;
    max-width: 100%;
    height: 80px;
    padding: 2px 10px 0 10px;
  }

  .number-value {
    text-align: center;
    width: 80px;
    max-width: 80px;
    font-size: 5rem !important;
    line-height: 4.2rem;
    font-weight: 400;
    float: left;
    padding: 0;
    margin-right: 10px;
    color: #32325d;
  }

  .number-title {
    font-size: .9rem;
    line-height: .875rem;
    font-weight: 500;
    width: calc(100% - 90px);
    height: 40px;
    float: right;
    padding-top: 10px;
    color: #32325d;
  }

  .number-owner {
    font-size: .75rem;
    line-height: .75rem;
    font-weight: 400;
    width: auto;
    float: right;
    height: 20px;
    margin-right: 10px;
    color: #32325d;
  }

  .icon-shape {
    display: inline-flex;
    padding: 12px;
    text-align: center;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
  }

  .icon {
    width: 3rem;
    height: 3rem;
    color: white;
  }

  .text-success {
    color: #2dce89!important;
  }

  h5 {
    font-size: 1.25rem !important;
  }

  .h2 {
    font-size: 2rem;
  }

  .font-semi-bold {
    font-weight: 500;
  }

  .card-table {
    border-radius: 6px;
    border: 1px solid #F0F0F0;
    box-shadow: 0px 5px 10px -5px rgba(0,0,0,0.125);
    padding-bottom: 20px;
    background-color: #FFF;
  }

  .card-dark {
    background-color: #172b4d !important;
  }

  .card-table.card-dark .caption-slx {
    color: #FFF !important;
  }

  .card-table .caption-slx {
    font-size: 1.25rem;
    font-weight: 500;
    padding: 20px;
    color: #111939;
  }

  .card-table .header {
    border-top: 1px solid #E0E0E0;
    border-bottom: 1px solid #E0E0E0;
    padding: 12px 6px;
    font-weight: 400;
    background-color: #F7F7F7 !important;
  }

  .card-table.card-dark .header {
    border-top: 1px solid #1C345D99;
    border-bottom: 1px solid #1C345D99;
    font-weight: 400;
    background-color: #1C345D !important;
  }

  .card-table .header .row {
    border-bottom: 1px solid #F7F7F7;
    padding: 0 !important;
  }

  .card-table.card-dark .header .row {
    border-bottom: 1px solid #1C345D;
    padding: 0 !important;
  }

  .card-table .header .row * {
    color: #111929;
    font-size: .875rem;
    font-weight: 500;
  }

  .card-table.card-dark .header .row * {
    color: #4D7BCA;
    font-size: .875rem;
  }

  .card-table .content {
    padding: 6px;
    font-weight: 400;
  }

  .card-table .content .row {
    border-bottom: 1px solid #F7F7F7;
    padding: 10px 0 !important;
  }

  .card-table.card-dark .content .row {
    border-bottom: 1px solid #1C345D;
    padding: 10px 0 !important;
  }

  .card-table .content .row * {
    color: #111939;
    font-size: .875rem;
  }

  .card-table.card-dark .content .row * {
    color: #F0F0F0;
    font-size: .875rem;
  }

  .font-light {
    font-weight: 400 !important;
  }

  .card-table .footer {
    font-weight: 500;
    padding: 20px 20px 0 0;
    color: #111939;
  }

  .card-table .footer .pagination {
    margin-bottom: 0px;
  }

  .date-change {
    background-color: #FFFFFF;
    outline:none;
  }
  
  .date-change:hover {
    background-color: #2dce89aa;
  }

  /*
  .card-table .footer .pagination .page-item {
    margin-right: 10px;
  }

  .card-table.card-dark .footer .pagination .page-item a {
    border: 1px solid #1C345D99;
    color: #4D7BCA;
    background-color: #1C345D !important;
  }

  .card-table.card-dark .footer .pagination .page-item.active a {
    border: 1px solid #1C345D99;
    color: #FFF;
    background-color: #4D7BCA !important;
  }

  .card-table .footer .pagination .page-item:last-child {
    margin-right: 0;
  }

  .card-table .footer .pagination .page-item a {
    cursor: pointer;
    text-align: center;
    border-radius: 0px !important
  }
  */
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue